import SolidityContract from '@exodus/solidity-contract';
import abi from '../abi.json';
import { TransactionDecoderError } from '../../../errors.js';
class GenericSwapTransactionDecoder {
    _values;
    constructor(values) {
        this._values = values;
    }
    decodeInput() {
        const values = this._values.flatMap((value) => getValueFromDecodedTxInput(value));
        const [transactionId, integrator, referrer, receiver, minAmount, ...swapInfo] = values;
        const transactionInfo = {
            transactionId,
            integrator,
            referrer,
            receiver,
            minAmount,
            swapData: [],
        };
        if (swapInfo.length % 7 !== 0) {
            throw new TransactionDecoderError({ message: 'expected swapInfo to be a multiple of 7' });
        }
        for (let i = 0; i < swapInfo.length; i += 7) {
            transactionInfo.swapData.push({
                callTo: swapInfo[i],
                approveTo: swapInfo[i + 1],
                sendingAssetId: swapInfo[i + 2],
                receivingAssetId: swapInfo[i + 3],
                fromAmount: swapInfo[i + 4],
                callData: swapInfo[i + 5],
                requiresDeposit: swapInfo[i + 6],
            });
        }
        return transactionInfo;
    }
}
class SwapAndStartBridgeTokensDecoder {
    _values;
    constructor(values) {
        this._values = values;
    }
    decodeInput() {
        const values = this._values.flatMap((value) => getValueFromDecodedTxInput(value));
        const [transactionId, bridge, integrator, referrer, sendingAssetId, receiver, minAmount, destinationChainId, hasSourceSwaps, hasDestinationCall, callTo, approveTo, sendingAssetId2, receivingAssetId, fromAmount, callData, requiresDeposit,] = values;
        return {
            transactionId,
            bridge,
            integrator,
            referrer,
            sendingAssetId,
            receiver,
            minAmount,
            destinationChainId,
            hasSourceSwaps,
            hasDestinationCall,
            swapData: [
                {
                    callTo,
                    approveTo,
                    sendingAssetId: sendingAssetId2,
                    receivingAssetId,
                    fromAmount,
                    callData,
                    requiresDeposit,
                },
            ],
        };
    }
}
class TransactionDecoderStrategy {
    _decoder = null;
    _method = '';
    constructor(rawTransactionInput, fromAddress) {
        const contract = new SolidityContract(JSON.stringify(abi), fromAddress);
        const decodedInput = contract.decodeInput(rawTransactionInput);
        this._method = decodedInput.method;
        if (['swapTokensGeneric', 'swapTokensMultipleV3NativeToERC20'].includes(decodedInput.method)) {
            this._decoder = new GenericSwapTransactionDecoder(decodedInput.values);
        }
        else if ([
            'swapAndStartBridgeTokensViaAcross',
            'swapAndStartBridgeTokensViaHopL1ERC20',
            'swapAndStartBridgeTokensViaHopL2ERC20',
        ].includes(decodedInput.method)) {
            this._decoder = new SwapAndStartBridgeTokensDecoder(decodedInput.values);
        }
    }
    decodeInput() {
        if (!this._decoder) {
            throw new TransactionDecoderError({
                message: `Failed to validate transaction; unknown ${this._method} decoder.`,
            });
        }
        return this._decoder.decodeInput();
    }
}
const getValueFromDecodedTxInput = (value) => {
    if (Array.isArray(value)) {
        return value.flatMap((value) => getValueFromDecodedTxInput(value));
    }
    if (typeof value === 'object' && typeof value._hex === 'string') {
        return [value._hex];
    }
    return [value];
};
const decodeTransaction = (rawTransactionInput, fromAddress) => {
    const transactionDecoder = new TransactionDecoderStrategy(rawTransactionInput, fromAddress);
    return transactionDecoder.decodeInput();
};
export default decodeTransaction;
